import React from 'react';

import Tooltip from "@mui/material/Tooltip";
import InfoIcon from "@mui/icons-material/Info";
import Badge from "@mui/material/Badge";

type HeaderBtnBadgeProps = {
    children: React.ReactNode
    tooltip?: string |null
}

const HeaderBtnBadge: React.FC<HeaderBtnBadgeProps> = ({children, tooltip}) => {
    return (
        <Badge sx={{"& .MuiBadge-badge": {backgroundColor: "transparent"}}}
               badgeContent={<Tooltip disableFocusListener disableTouchListener arrow
                                      placement="top"
                                      title={(tooltip) ? tooltip : "In der ersten Version nocht nicht möglich."}>
                   <InfoIcon sx={{color: "darkgray"}}/>
               </Tooltip>} color="primary">
            {children}
        </Badge>
    );
};

export default HeaderBtnBadge;